<ui-kit-modal [size]="SizeScheme.Medium" [hideCloseButton]="true">
  <ng-template uiKitModalTitle>Update Available</ng-template>

  <ng-template uiKitModalContent>
    <p>A new version of this application is available. Please refresh the page to continue.</p>
  </ng-template>

  <ng-template uiKitModalCloseButton>
    <button uiKitButton theme="filled" color="secondary" (click)="onRefresh()">Refresh</button>
  </ng-template>
</ui-kit-modal>
